import api from './api';

/**
 * Busca informações de endereço para um CEP usando a API do backend (que tem redundância).
 *
 * @param {string} cep — 8 dígitos (com ou sem máscara)
 * @returns {{ logradouro, bairro, city, state, zip, ibge }}
 * @throws {Error} se não encontrar
 */
export async function lookupCep(cep) {
  const raw = String(cep).replace(/\D/g, '');
  if (raw.length !== 8) throw new Error('CEP deve ter exatamente 8 dígitos');

  try {
    const res = await api.get(`/addresses/cep/${raw}`);
    return res.data;
  } catch (err) {
    throw new Error(`CEP ${maskCepDisplay(raw)} não encontrado.`);
  }
}

function maskCepDisplay(d) {
  return d.length === 8 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
}
